const CarbonCreditFuturesPool = {
  "_format": "hh-sol-artifact-1",
  "contractName": "CarbonCreditFuturesPool",
  "sourceName": "contracts/core/CarbonCreditFuturesPool.sol",
  "abi": [
    {
      "inputs": [],
      "name": "BAD_INDEX",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_INPUT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CLOSED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CLOSE_AFTER_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZE_BEFORE_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_SHARES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SLIPPAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOO_EARLY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UNCLAIMED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_TIMESTAMP",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CreditCollected",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CreditsClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "Deposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalShares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "creditTypesCount",
          "type": "uint256"
        }
      ],
      "name": "Finalized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "RefundClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "RefundCollected",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "SharesRedeemed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "project",
          "type": "address"
        }
      ],
      "name": "UnderlyingAdded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimAllUnderlyings",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimTimestamp",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "indices",
          "type": "uint256[]"
        }
      ],
      "name": "claimUnderlyings",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "collectedCredits",
      "outputs": [
        {
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "isERC1155",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "collectedCreditsCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "investmentTokens",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256",
          "name": "minSharesOut",
          "type": "uint256"
        }
      ],
      "name": "deposit",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "sharesOut",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "depositCloseTime",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalizeEarliestTime",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalized",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        }
      ],
      "name": "getCollectedCredit",
      "outputs": [
        {
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "isERC1155",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "factory_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "stableCoin_",
          "type": "address"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp_",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "depositCloseTime_",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "finalizeEarliestTime_",
          "type": "uint64"
        },
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "redeem",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalRefundAtFinalize",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSharesAtFinalize",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "underlyingCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "underlyings",
      "outputs": [
        {
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "claimed",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default CarbonCreditFuturesPool;
